import { useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import ImageUploader from '../ImageUploader/ImageUploader'
import { reExportedColors, Text } from '../../1elements'
import CancelIconButton from '../../1elements/Buttons/IconButtons/CancelIconButton/CancelIconButton'
import ImageUploadButton from '../../1elements/Buttons/TextButtons/ImageUploadButton/ImageUploadButton'
import { englishTexts } from '../../../consts/Texts'
import useImageUpload from '../../../services/customHooks/useImageUpload'

const LocationImageUploader = ({ imageFile, setImageFile }) => {
  const theme = useTheme()
  const [error, setError] = useState('')
  const { open } = useImageUpload(setImageFile, 2000 * 1000, setError)
  const instructionStyle = {
    color: theme.palette.tertiary.accent,
    textAlign: 'center'
  }

  return (
    <div>
      {imageFile
        ? (
          <Box sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '290px',
            position: 'relative',
            width: '220px'
          }}>
            <Box sx={{ position: 'absolute', right: '10px', top: '10px' }}>
              <CancelIconButton onClick={() => setImageFile(null)} />
            </Box>
            <Box
              component='img'
              alt=''
              src={imageFile[0].preview}
              onLoad={() => { URL.revokeObjectURL(imageFile[0].preview) }}
              sx={{
                borderRadius: '5%',
                height: '190px',
                objectFit: 'cover',
                width: '190px'
              }}
            />
            <Box sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              marginTop: '10px',
              '& > *': { marginTop: '5px' }
            }}>
              <ImageUploadButton onClick={open} />
              <Text type='h6' style={instructionStyle}>
                {englishTexts.imageUploader.finePrint}
              </Text>
              <Text type='h6' style={{ color: reExportedColors.RED }}>
                {error}
              </Text>
            </Box>
          </Box>
          )
        : (
          <ImageUploader
            imageFile={imageFile}
            setImageFile={setImageFile}
            sx={{
              borderRadius: '5%',
              height: '190px',
              marginTop: '30px',
              objectFit: 'cover',
              width: '200px'
            }}
          />
          )}
    </div>
  )
}

export default LocationImageUploader
